import React from 'react';

export type Mp4GifEmulatorProps = {
  src: string;
  className?: string;
};

/**
 * ```import { Mp4GifEmulator } from '@zola/zola-ui/src/components/Mp4GifEmulator';```
 *
 * Renders an mp4 video file that displays like a gif.
 *
 * Since gif files can be large and non-performant, mp4 files with the same animation can be rendered in a loop to appear as a gif.
 */
const Mp4GifEmulator: React.FC<Mp4GifEmulatorProps> = ({ src, className }) => (
  <video autoPlay loop playsInline muted className={className}>
    <source src={src} type="video/mp4" />
  </video>
);

export default Mp4GifEmulator;
